import type { BreadcrumbItem } from 'packages/swf-help/center/src/types';
import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';

import { getVertical } from '../../utils';

import { TXTWCL_N0_Help_home } from './Breadcrumb.messages.json';
import styles from './Breadcrumb.scss';

const Breadcrumb: React.FC<BreadcrumbItem> = ({ id, title }) => {
  const vertical = getVertical(useSelector(select.page.getVertical));

  return (
    <div className={styles.container}>
      <Link route={RoutingKey.HelpCenter}>
        <Translation values={{ 0: vertical }} {...TXTWCL_N0_Help_home} />
      </Link>
      <Arrow className={styles.arrow} width={12} height={12} />
      {id === 'search-id' ? (
        <span>{title}</span>
      ) : (
        <Link route={RoutingKey.HelpCenterCategoryArticles} values={{ category: id }}>
          {title}
        </Link>
      )}
    </div>
  );
};

export default Breadcrumb;
